import axios from 'axios';
import router from '@/router';
import store from '@/store';

export const linkObj = {
  register: '',
  privacy: ''
};
/** 获取接口协议 */
export function getAgreement () {
  axios({
    method: 'get',
    baseURL: process.env.VUE_APP_BASE_COMMUNITY_ADMIN,
    url: '/member/getAgreement',
    params: {}
  }).then(({ data }) => {
    const { register, privacy } = data.data;
    linkObj.register = register;
    linkObj.privacy = privacy;
  });
}

export function showPrivacy () {
  store.commit('setKeepAliveArr', [router.currentRoute.value.name]);

  router.push({
    name: 'iframe',
    query: { title: '隐私政策', link: linkObj.privacy }
  });
}
export function showRegister () {
  store.commit('setKeepAliveArr', [router.currentRoute.value.name]);

  router.push({
    name: 'iframe',
    query: { title: '用户协议', link: linkObj.register }
  });
}
